import { combineReducers } from '@reduxjs/toolkit';
import pdcMeetingDetailReducer from './meetingDetailSlice';
import meetingProgressBarReducer from './meetingProgressBarSlice';
import pdcSupportingDocumentsReducer from './pdcSupportingDocumentSlice';
import pdcSummaryTableViewReducer from './pdcSummaryTableViewtSlice';

const reducer = combineReducers({
  prePDCMeeting: pdcMeetingDetailReducer,
  meetingStepperDetail: meetingProgressBarReducer,
  pdcSupportingDocuments: pdcSupportingDocumentsReducer,
  pdcSummaryTableView: pdcSummaryTableViewReducer
});

export default reducer;
